import React from "react";
import "./AvametLinks.css";

const links = [
  { label: "Casas Verdes", url: "https://www.avamet.org/mxo_i.php?id=c13m190e01" },
  { label: "Fte del Jarro Asivalco", url: "https://www.avamet.org/mxo_i.php?id=c13m190e02" },
  { label: "P Tecnológico AIDIMME", url: "https://www.avamet.org/mxo_i.php?id=c13m190e05" },
  { label: "Estación", url: "https://www.avamet.org/mxo_i.php?id=c13m190e04" }
];

const AvametLinks = () => {
  return (
    <div className="avamet-outer-container">
        <div className="avamet-container">
        <span className="avamet-title">Meteos avamet</span>

        <nav className="avamet-links">
            {links.map((link) => (
            <a
                key={link.url}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="avamet-link"
            >
                {link.label}
            </a>
            ))}
        </nav>
        </div>
    </div>
  );
};

export default AvametLinks;
